import { useEffect, useRef, useState } from 'react';

export default function useCostCalculator1(
  cartoonSize,
  costingheads,
  totalMasterPC,
  updatingCalc,
  fieldData,
  setFieldData,
  reload,
  reload2,
  costingTableData,
  showTables,
  state,
  totalCBMperpc,
  changeCount
) {
  useEffect(() => {
    let tempOutcost = 0; // Start with the initial outcost value
    let tempIncost = 0; // Start with the initial incost value
    if (
      cartoonSize.length == 1 &&
      cartoonSize[0].Carton_Length == 0 &&
      cartoonSize[0].Carton_Width == 0 &&
      cartoonSize[0].Carton_Thick == 0
    ) {
    } else {
      cartoonSize.forEach(element => {
        const { Carton_Length, Carton_Width, Carton_Thick, Carton_Unit, Carton_PCS, CartonType } =
          element;

        if (Carton_Length == 0 && Carton_Width == 0 && Carton_Thick == 0) {
          return;
        }

        if (Carton_PCS !== 0) {
          let unitvalue = 1;
          if (Carton_Unit === 'inch') {
            unitvalue = 2400;
          } else if (Carton_Unit === 'cm') {
            unitvalue = 15483.84;
          }

          const cartonVolume =
            (((Carton_Length + Carton_Width) * 2 + 2) * (Carton_Width + Carton_Thick + 0.5)) / unitvalue;

          if (CartonType === 'master') {
            tempOutcost += (cartonVolume * costingheads.MasterCarton) / Carton_PCS;
          } else {
            tempIncost += (cartonVolume * costingheads.Innercarton) / Carton_PCS;
          }
        }
      });
      setFieldData(prev => ({
        ...prev,
        innercost: tempIncost.toFixed(2) || 0,
        mastercost: tempOutcost.toFixed(2) || 0
      }));
    }
  }, [cartoonSize, cartoonSize.Carton_Length, cartoonSize.Carton_Width, cartoonSize.Carton_Thick]);

  useEffect(() => {
    setFieldData(prev => ({
      ...prev,
      shippingcost: Number(costingheads.FOB * totalCBMperpc) || 0
    }));
  }, [costingheads.FOB, totalCBMperpc]);

  useEffect(() => {
    // console.log('overallcost');
    // console.log(fieldData.overallcost);
  }, [fieldData.overallcost]);

  const [count, setCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount(prevCount => {
        if (prevCount >= 99) {
          return 0; // Reset the counter when it reaches 100
        }
        return prevCount + 1; // Increase count by 1 every 2 seconds
      });
    }, 1000); // Update every 2 seconds

    // Clear interval on component unmount
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const calculateTotal = async () => {
      let firstTableTotal = 0;
      let secondTableTotal = 0;
      let thirdTableTotal = 0;
      let fourthTableTotal = 0;
      let fifthTableTotal = 0;
      let sixTotal = 0;
      let profilePercentage = 0;
      let profileAmount = 0;
      let USD = 0;
      let Gstcost = 0;
      let testingcost = 0;
      let othercost = 0;
      let laisoncost = 0;
      let overheadcost = 0;
      let misccost = 0;
      let innercost = 0;
      let mastercost = 0;
      let shippingcost = 0;
      let polishcost = 0;
      let itemcost = 0;
      let gstcost = 0;
      let laisoncost2 = 0;
      let testingcost2 = 0;
      let othercost2 = 0;
      let overheadcost2 = 0;
      let misccost2 = 0;

      // Custom calculateTotal function (updated for async)
      const calculateTotalAsync = async (tableData, key) => {
        return new Promise(resolve => {
          if (tableData.some(item => item[key] !== '')) {
            const total = tableData.reduce((total, item) => {
              return total + (parseFloat(item[key]) || 0);
            }, 0);
            resolve(total);
          } else {
            resolve(0);
          }
        });
      };

      // Custom calculations
      if (!showTables.material) {
        firstTableTotal = Number(fieldData.Netwgt) * Number(fieldData.perkgrate);
      } else {
        firstTableTotal = await calculateTotalAsync(
          costingTableData.CostingMaterial,
          'totalmaterialcost'
        );
      }

      if (!showTables.process) {
        thirdTableTotal = Number(fieldData.size) * Number(fieldData.rate);
      } else {
        thirdTableTotal = await calculateTotalAsync(costingTableData.CostingProcess, 'prcsamt');
      }
      
      if (!showTables.accessories && (fieldData.createdAt || updatingCalc.Accessories)) {
        // console.log('if');
        // console.log('fieldData',fieldData);
        fourthTableTotal = fieldData.accessorycost / 1;
      } else {
        fourthTableTotal = await calculateTotalAsync(costingTableData.CostingAccessory, 'matcost');
      }

      if (!showTables.packing && (fieldData.createdAt || updatingCalc.Packing)) {
        fifthTableTotal = fieldData.packingcost / 1;
      } else {
        fifthTableTotal = await calculateTotalAsync(costingTableData.Costingpacking, 'packingtotalcost');
      }
      if (!showTables.wood) {
      } else {
        secondTableTotal = await calculateTotalAsync(costingTableData.CostingWood, 'woodamount');
      }

      if (fieldData.fittingcost) {
        sixTotal = +fieldData.fittingcost;
      }
      if (fieldData.gstcost) {
        Gstcost = +fieldData.gstcost;
      }
      if (fieldData.testingcost) {
        testingcost = +fieldData.testingcost;
      }
      if (fieldData.othercost) {
        othercost = +fieldData.othercost;
      }
      if (fieldData.laisoncost) {
        laisoncost = +fieldData.laisoncost;
      }
      if (fieldData.overheadcost) {
        overheadcost = +fieldData.overheadcost;
      }
      if (fieldData.misccost) {
        misccost = +fieldData.misccost;
      }
      if (fieldData.innercost) {
        innercost = +fieldData.innercost;
      }
      if (fieldData.mastercost) {
        mastercost = +fieldData.mastercost;
      }
      if (fieldData.shippingcost) {
        shippingcost = +fieldData.shippingcost;
      }
      if (fieldData.polishcost) {
        polishcost = +fieldData.polishcost;
      }

      if (fieldData.Netwgt && fieldData.perkgrate) {
        itemcost = firstTableTotal;
      } else {
        itemcost = firstTableTotal + secondTableTotal;
      }

      const finishcost = thirdTableTotal;
      const accessorycost = fourthTableTotal;
      const fittingcost = fifthTableTotal;

      const totalCost =
        firstTableTotal +
        secondTableTotal +
        thirdTableTotal +
        fourthTableTotal +
        fifthTableTotal +
        sixTotal +
        innercost +
        mastercost;

      const totalCost2 = totalCost + testingcost + othercost + laisoncost;
      const totalCost3 = totalCost2 + overheadcost;
      const totalCost4 = totalCost3 + misccost + shippingcost;

      if (fieldData.currencyRate && fieldData.targetCost2) {
        USD = +fieldData.targetCost2 / +fieldData.currencyRate;
      }

      if (fieldData.laisonper) {
        const result = (+totalCost.toFixed(2) * +fieldData.laisonper) / 100;
        laisoncost2 = +result.toFixed(2);
      }

      if (fieldData.testingper) {
        const result = (+totalCost.toFixed(2) * +fieldData.testingper) / 100;
        testingcost2 = +result.toFixed(2);
      }

      if (fieldData.otherper) {
        const result = (+totalCost.toFixed(2) * +fieldData.otherper) / 100;
        othercost2 = +result.toFixed(2);
      }

      if (fieldData.overheadper) {
        const result = (+totalCost2.toFixed(2) * +fieldData.overheadper) / 100;
        overheadcost2 = +result.toFixed(2);
      }

      if (fieldData.miscper) {
        const result = (+totalCost3.toFixed(2) * +fieldData.miscper) / 100;
        misccost2 = +result.toFixed(2);
      }

      setFieldData(prev => ({
        ...prev,
        itemcost: +itemcost.toFixed(2),
        finishcost: +finishcost.toFixed(2),
        accessorycost: +accessorycost.toFixed(2),
        packingcost: +fittingcost.toFixed(2),
        totalinr: +totalCost4.toFixed(2),
        targetcostUSD: +USD.toFixed(2),
        overallcost: +totalCost.toFixed(2),
        subtotalcost: +totalCost2.toFixed(2),
        subtotalwohcost: +totalCost3.toFixed(2),
        laisoncost: updatingCalc.Laisoncost ? fieldData.laisoncost : laisoncost2,
        testingcost: updatingCalc.Testingcost ? fieldData.testingcost : testingcost2,
        othercost: updatingCalc.Othercost ? fieldData.othercost : othercost2,
        overheadcost: updatingCalc.OverHeadcost ? fieldData.overheadcost : overheadcost2,
        misccost: updatingCalc.Misccost ? fieldData.misccost : misccost2
      }));
    };

    calculateTotal();
  }, [
    // showTables,
    // reload,
    // reload2,
    // changeCount,
    // // state.costingId,
    // fieldData.overallcost,
    // fieldData.subtotalcost,
    // fieldData.subtotalwohcost,
    // fieldData.innercost,
    // fieldData.mastercost,
    // fieldData.shippingcost
    count
  ]);

  useEffect(() => {
    if (state.Currencyrate.id && state?.Currencyrate?.exchangerate) {
      setFieldData(prev => ({
        ...prev,
        currencyRate: prev.currencyRate ?? state?.Currencyrate?.exchangerate
      }));
    }
  }, [state.Currencyrate]);

  return null;
}
